import Link from 'next/link';
import React from 'react';

export const Footer = () => {
  return (
    <>
      <footer className="footer privacy without-cta">
        <div className="container">
          <div className="privacy__row">
            <div className="left">
              <div className="footer__menu">
                <Link
                  className="footer__menu__link text--regular text--white"
                  href="/terms-and-conditions"
                  id="footer_terms"
                >
                  Terms & Condition
                </Link>
                <span className="pipe text--regular text--white">|</span>
                {/* <a
                  className="footer__menu__link text--regular text--white"
                  href="#"
                >
                  Security
                </a> */}
                {/* <span className="pipe text--regular text--white">|</span> */}
                <Link
                  className="footer__menu__link text--regular text--white"
                  href="/privacy-policy"
                  id="footer_privacy"
                >
                  Privacy
                </Link>
              </div>
            </div>
            <div className="right">
              <div className="mobile-view">
                <p className="text--white text--regular">
                  Need help? Visit the{' '}
                  <Link
                    href="/help"
                    className="text--white text--bold"
                    id="footer_help"
                  >
                    Help Center
                  </Link>{' '}
                  or{' '}
                  <Link
                    href="/help"
                    className="text--white text--bold"
                    id="footer_contact"
                  >
                    Contact Us
                  </Link>
                </p>
              </div>
              <p className="text--white text--regular web-view">
                Need help? Visit the {''}
                <Link
                  href="/help"
                  className="text--white text--bold"
                  id="footer_help-center"
                >
                  Help Center
                </Link>{' '}
                or{' '}
                <Link
                  href="/help"
                  className="text--white text--bold"
                  id="footer_contact-us"
                >
                  Contact Us
                </Link>
              </p>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};
